import { useMemo } from "react";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { useRacehorse360Api } from "hooks/api";

interface IUseFacilityBarnsReturnType {
  facilityBarns: Pick<racehorse360.IBarn, "id" | "name">[];
  isLoading: boolean;
}

export const useFacilityBarns = (
  facilityId: string
): IUseFacilityBarnsReturnType => {
  const { useListBarns } = useRacehorse360Api();

  const { data, isLoading } = useListBarns(
    {
      query: { facilityId: facilityId },
      getOptions: {
        select: ["name"],
        orderBy: ["name"]
      }
    },
    {
      enabled: Boolean(facilityId)
    }
  );

  const facilityBarns = data?.barns.map(barn => ({
    id: barn.id,
    name: barn.name
  }));

  return useMemo(
    () => ({
      facilityBarns,
      isLoading
    }),
    [data, isLoading]
  );
};
